import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  PRODUCT_SURVEILLANCE,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_BAXTER_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_BAXTER,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_BAXTER_EMPLOYEE,
  DATE_MESSAGE_BAXTER_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_BAXTER_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_BAXTER_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  BAXTER_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  BAXTER_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_BAXTER,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  BAXTER_EMAIL_ADDRESS,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  BAXTER_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_BAXTER,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Ürün Geribildirim Portalı";
translations[LANDING_BRIEF] = "Baxter online Ürün Geribildirim Portalı, Baxter ürünleri hakkında gizli bilgilerin ve geri bildirimlerin sunulması için tasarlanmıştır.";
translations[LANDING_LANGUAGE_SELECTOR] = "Dil Tercihinizi Seçiniz";
translations[LANDING_COUNTRY_SELECTOR] = "Olayın Meydana Geldiği Ülkeyi Seçiniz";
translations[LANDING_TERMS] = "Baxter'ın Ürün Geri Bildirim Portalı Kullanım Koşullarını ve Gizlilik Bildirimini okudum ve kabul ediyorum.";
translations[LANDING_TERMS_ERROR] = "Baxter Ürün Geri Bildirim Portalı için Kullanım Koşulları, Gizlilik Bildirimi ve Baxter Ürün Geri Bildirim Portalı Ek Kullanım Koşulları ve Gizlilik Bildirimi'nin içeriğini okumalı ve kabul etmelisiniz.";
translations[LANDING_CAPTCHA_ERROR] = "Lütfen robot olmadığınızı doğrulayın.";
translations[APP_DESCRIPTION] = "Baxter online Ürün Geribildirim Portalı ürünlerle ilgili bilgilerin sunulması için tasarlanmıştır.Bir Baxter ürünüyle ilgili herhangi bir sorunla karşılaştıysanız, o olayın ayrıntılarını paylaşmanızı öneririz. Tüm geri bildirimler, ürün ve memnuniyeti sürekli iyileştirmeye yönelik ortak hedeflerimizi gerçekleştirmemiz için esastır.";
translations[LANDING_TERMS_I_HAVE_READ] = "Baxter Ürün Geri Bildirim Portalı için bağlantılı Gizlilik Bildirimini okudum ve Baxter Healthcare Corporation'ın (“Baxter”) kişisel verilerimi Gizlilik Bildiriminde açıklanan amaçlar doğrultusunda kullanmak, ifşa etmek ve işlemek için onayımı istediğini anlıyorum. İşbu belge ile şunları kabul ediyorum:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "Kişisel verilerimin (sağlamayı seçtiğim sağlıkla ilgili veriler gibi hassas veriler dahil) Gizlilik Bildiriminde belirtilen amaçlar için kullanılması, ifşa edilmesi, saklanması ve işlenmesi.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "Kişisel verilerimin (sağlamayı seçtiğim sağlıkla ilgili veriler gibi hassas veriler dahil) ülkemden ve daha az katı olabilecek veya veri koruma yasaları olmayan başka bir ülkeye aktarılması.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Bu onayın isteğe bağlı olduğunu ve istediğim zaman fikrimi değiştirebileceğimi ve Gizlilik Bildiriminde sağlanan iletişim bilgilerini kullanarak Baxter ile iletişime geçerek onayımı iptal edebileceğimi anlıyorum. Onayımı geri çekmenin, geri çekilmeden önce işlemenin yasallığını etkilemeyeceğini anlıyorum.";
translations[MENU_FEEDBACK_FORM] = "Ürün Geri Bildirimini Başlat";
translations[MENU_FEEDBACK_STATUS] = "Ürün Geri Bildirim Durumunu Kontrol Edin";
translations[MENU_FORM_INTAKE] = "Raportör / Kontakt Bilgileri";
translations[MENU_FORM_EVENT_DETAILS] = "Olay Detayları";
translations[MENU_FORM_PRODUCT_INFO] = "Ürün Bilgileri";
translations[SYSTEM_FEEDBACK_FORM] = "Ürün Geri Bildirim Formunu Başlat";
translations[SYSTEM_FEEDBACK_STATUS] = "Ürün Geri Bildirim Durumunu Kontrol Edin";
translations[SUBMIT_FEEDBACK] = "Geri bildirim göndermek için buraya tıklayın.";
translations[CHECK_SUBMITTED_FEEDBACK] = "Daha önce gönderilen geri bildirim durumunu kontrol etmek için buraya tıklayın.";
translations[BTN_LAUNCH_FORM] = "Başlangıç";
translations[BTN_CHECK_STATUS] = "Durumu Kontrol Et";
translations[FORM_TITLE] = "Ürün Geri Bildirim Formu";
translations[FORM_SUB_TITLE] = "Etkilenen birden fazla hasta varsa, lütfen her hasta için bir form doldurun.";
translations[FORM_MANDATORY_FIELDS] = "* işaareti olan alanların doldurulması zorunludur";
translations[BUTTON_PREV] = "Önceki";
translations[BUTTON_NEXT] = "Sonraki";
translations[BUTTON_SUBMIT] = "Gönder";
translations[SELECT_RESPONSE] = "Yanıtı seçiniz";
translations[FUNCTION_ROLE] = "Fonksiyon/Rol";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Müşteri Hesap Numarası";
translations[ENTER_CUSTOMER_ACCOUNT] = "Müşteri Hesabını Giriniz";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Raporlanan olaya dahil olan müşteri numarası nedir?";
translations[EVENT_REPORTED] = "Bu olay daha önce bildirildi mi (Baxter veya başka bir kuruluşça)?";
translations[REFERENCE_NUMBER] = "Bu olayla ilişkili referans numarası";
translations[ENTER_REFERENCE] = "Referansı Giriniz";
translations[WHO_REPORTED_TO] = "Olay kime bildirildi? ";
translations[WHO_WAS_NOTIFIED] = "Kimin bilgilendirildiğini belirtin";
translations[ENTER_NAME] = "İsim giriniz";
translations[PRODUCT_SURVEILLANCE] = "Başka soruların olması halinde Ürün Gözetimi / Baxter sizinle veya başka biriyle iletişime geçebilir mi?";
translations[YOUR_NAME] = "Adınız";
translations[OCCUPATION] = "Meslek";
translations[PHONE_NUMBER] = "Telefon Numarası";
translations[ENTER_PHONE_NUMBER] = "Telefon Numarasını Giriniz";
translations[ENTER_EMAIL] = "E-posta giriniz";
translations[EMAIL_ADDRESS] = "e-Mail Adresi";
translations[ENTER_ADDRESS] = "E-Posta Adresinizi Giriniz";
translations[ENTER_NA_IF_UNKNOWN] = "Bilinmiyorsa N/A giriniz";
translations[FACILITY_HOSPITAL] = "Kurum/Hastane veya Distribütör Adı (varsa)";
translations[ENTER_FACILITY] = "Kurumu Giriniz";
translations[ADDRESS_1] = "Adres 1";
translations[ADDRESS_2] = "Adres 2";
translations[CITY] = "Şehir";
translations[STATE] = "Devlet";
translations[POSTAL_CODE] = "Posta kodu";
translations[COUNTRY] = "Ülke";
translations[END_USER_CUSTOMER] = "Bu sorun bir son kullanıcı/müşteri tarafından mı saptandı?";
translations[ADDITIONAL_CONTACT_PERSON] = "Ek Kontakt Kişi";
translations[ADDITIONAL_PHONE] = "Ek Kontakt Telefon Numarası";
translations[ADDITIONAL_EMAIL] = "Ek Kontakt e-Mail ";
translations[ANOTHER_FACILITY_ADDRESS] = "Başka kurum/ adres ekleyin";
translations[ANOTHER_FACILITY_HOSPITAL] = "Başka kurum/Hastane veya Distribütör Adı (varsa)";
translations[ANOTHER_ENTER_FACILITY] = "Kurumu Giriniz";
translations[ANOTHER_ADDRESS_1] = "Adres 1";
translations[ANOTHER_ADDRESS_2] = "Adres 2";
translations[ANOTHER_CITY] = "Şehir";
translations[ANOTHER_STATE] = "Devlet";
translations[ANOTHER_POSTAL_CODE] = "Posta kodu";
translations[ANOTHER_COUNTRY] = "Ülke";
translations[LOT_SERIAL_NUMBER] = "Parti Numarası / Seri Numarası";
translations[ENTER_LOT_SERIAL_NUMBER] = "Lot Numarasını / Seri Numarasını Giriniz";
translations[HELP_LOT_SERIAL_NUMBER] = "Lot/Seri numarasını bilmiyorsanız veya raportöre sorduysanız ve o da bilmiyorsa Bilinmiyor seçeneğini seçin.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Ürün Kodu";
translations[PRODUCT_CODE] = "Ürün Kodu";
translations[ENTER_PRODUCT_CODE] = "Ürün Kodunu Giriniz";
translations[HELP_PRODUCT_CODE] = "Ürün kodunu bilmiyorsanız veya raportöre sorduysanız ve o da bilmiyorsa Bilinmiyor seçeneğini seçin.";
translations[NDC] = "Ulusal İlaç Kodu (NDC) Numarası";
translations[ENTER_NDC] = "NDC giriniz";
translations[UDI] = "Tekil Cihaz Tanımlayıcı (UDI)";
translations[ENTER_UDI] = "UDI giriniz";
translations[PRODUCT_NAME] = "Ürün Adı";
translations[ENTER_PRODUCT_NAME] = "Ürün Adını Giriniz";
translations[HELP_PRODUCT_NAME] = "Ürünün adını veya açıklamasını belirtiniz";
translations[BEST_DESCRIBES] = "Lütfen bildirilen sorunu en iyi açıklayan seçimi yapın";
translations[QUANTITY_TO_SELECT] = "Seçilecek Miktar";
translations[ENTER_QUANTITY] = "Miktar giriniz";
translations[HELP_QUANTITY] = "Raporlanan probleme dahil olan olan ürün sayısı";
translations[UNIT] = "Birim";
translations[AVAILABLE_TO_RETURNED] = "Bildirilen problemli ürün değerlendirme için Baxter'a iade edilebilir mi?";
translations[PHOTOGRAPH_AVAILABLE] = "Ürünün bir fotoğrafı veya videosu mevcut mu?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Bildirilen sorunun fotoğrafta veya videoda göründüğünden emin olunuz.";
translations[UPLOAD_IMAGES] = "Resim Yükle";
translations[REPORTER_NAME] = "Raporlayıcının Adı";
translations[REPORTER_FACILITY] = "Raporlayıcının Tesisi";
translations[REPORTER_OCCUPATION] = "Raporlayıcının Mesleği";
translations[ENTER_NUMBER] = "Numarayı giriniz";
translations[REPORTER_PHONE_NUMBER] = "Raporlayıcının Telefon Numarası";
translations[REPORTER_EMAIL_ADDRESS] = "Raporlayıcının E-posta Adresi";
translations[EMPLOYEE_NAME] = "Çalışan Adı";
translations[EMPLOYEE_PHONE_NUMBER] = "Çalışan Telefon Numarası";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Çalışan E-posta Adresi";
translations[RETURNING_FOR_INVESTIGATION] = "Bildirilen soruna istinaden kaç adet numuneyi (birim olarak) araştırma için için geri gönderiyorsunuz?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Bu numuneler, bildirilen sorunlu ürün olmalıdır.";
translations[UNUSED_BAXTER_PRODUCT] = "Araştırma için Baxter'a iade edilebilecek aynı lottan kullanılmayan bir Baxter Ürünü var mı?";
translations[YOU_INDICATED_SAMPLES] = "Numunelerin araştırma için sağlanabileceğini belirttiniz, bu numuneleri sağlık profesyonelinizden alabilir misiniz?";
translations[SAMPLE_RETURN_KIT] = "Numunelerin araştırma için sağlanabileceğini belirttiniz, numune iade kitini göndermek için lütfen verilen adresi onaylayın:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Numuneyi iade etmek için bu adrese ön ödemeli etiketli bir kutu gönderilecektir";
translations[SAME_AS_MY_ADDRESS] = "Adresim ile aynı";
translations[OTHER_CONTACT_NAME] = "Diğer Kontakt Adı";
translations[OTHER_CONTACT_OCCUPATION] = "Diğer Kontaktın Mesleği";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Diğer Kontaktın Telefon Numarası";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Diğer Kontaktın E-posta Adresi";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Seçtiğiniz ürün başka bir şirket tarafından üretiliyor, raporlamanız ile ilgili başka soruları varsa iletişim bilgilerinizi onlara verebilir miyiz?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Müşteri araştırma sonuçlarını açıkça talep etti mi?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Müşteri açıkça kredi istedi mi?";
translations[PRODUCT_FROM_BAXTER] = "Müşteri ürünü doğrudan Baxter'dan mı sipariş ediyor?";
translations[QUANTITY_REQUESTED_CREDIT] = "Lot numarası (lar) ve kredi için talep edilen miktar:";
translations[ENTER_OCCUPATION] = "Mesleği Giriniz";
translations[LOT_QUANTITY_NUMBER] = "Lot Numarasını ve miktarını giriniz";
translations[WHOLESALERS_NAME] = "Sağlayıcının adı ve yeri nedir (şehir, bçlge)";
translations[PLACE_WHOLESALERS_NAME] = "Sağlayıcının adı ve yeri nedir (şehir, bçlge)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Grid e ürün ekle";
translations[SAVE] = "Kaydet";
translations[CANCEL] = "İptal et";
translations[ADD_MORE_PRODUCTS] = "Daha Fazla Ürün Ekle";
translations[REPORTER_ADDRESS] = "Raporlayıcının Adresi";
translations[ATTACHMENTS] = "Ekler";
translations[DATE_OF_EVENT] = "Olayın meydana geliş tarihi";
translations[DATE_OF_EVENT_MSG] = "Olayın meydana geliş tarihi, Baxter Çalışanına ilk bildirildiği Tarihten sonra olamaz. Geçerli bir tarih giriniz";
translations[HELP_DATE_OF_EVENT] = "Olayın gerçekleştiği bilinen birden çok tarih varsa, lütfen her tarih için bir form doldurun.";
translations[DATE_BAXTER_EMPLOYEE] = "Baxter Çalışanının ilk bilgilendirildiği tarih";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(Sağlanan tarih, bilgilerin girildiği tarihle aynı olmak zorunda değildir.)";
translations[DURING_WHAT_PROCESS] = "Olay hangi adım(lar)da meydana geldi?";
translations[WAS_THE_PATIENT] = "Olay sırasında hasta bağlı mıydı (tedavi devam ederken)?";
translations[WERE_YOU_CONNECTED] = "Olayın gerçekleştiği sırada cihaza bağlı mıydınız?";
translations[PROVIDE_ANY_ADDITIONAL] = "Olay/problemle ilgili ek ayrıntıları sağlayın";
translations[HELP_YOU_IDENTIFIED_MORE] = "Birden fazla ürün ve sorun belirtilmiştir, lütfen hangi ürünlerin hangi sorunlarla eşleştiğini belirtiniz. ";
translations[ENTER_DETAILS] = "Ayrıntıları giriniz";
translations[PROVIDE_ANY_ATTACHMENT] = "Varsa ek sağılayınız";
translations[WAS_NEGATIVE_MEDICAL] = "Olayın sonucunda herhangi bir olumsuz tıbbi etki, semptom(lar) veya yaralanma oldu mu?";
translations[WAS_MEDICAL_INTERVENTION] = "Bildirilen olayı önlemek için tedavi, tıbbi müdahale veya bakımın artırılması sağlandı mı?";
translations[PROVIDE_DETAILS] = "Detayları sağlayın";
translations[REQUIRED_TREATMENT] = "Gerekli tedavi / tıbbi müdahale";
translations[ENTER_TREATMENT] = "Tedaviyi giriniz";
translations[RELEVANT_TESTS] = "Laboratuvar verileri de dahil olmak üzere ilgili testler:";
translations[HELP_RELEVANT_TESTS] = "İlgili testleri giriniz";
translations[RELEVANT_MEDICAL_HISTORY] = "Önceden var olan tıbbi durumlar da dahil olmak üzere ilgili tıbbi geçmiş:";
translations[ENTER_HISTORY] = "Geçmişi giriniz";
translations[PATIENT_NAME] = "Hastanın Adı";
translations[PATIENT_INITIALS] = "Hastanın baş harfleri veya tam adı. Etkilenen birden fazla hasta varsa, lütfen her hasta için bir form doldurun.";
translations[PATIENT_PHONE_NUMBER] = "Hasta Telefon Numarası";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Sağlamak / vermek istemiyorum";
translations[PATIENT_EMAIL_ADDRESS] = "Hasta E-posta Adresi";
translations[PATIENT_ADDRESS] = "Hasta Adresi";
translations[SAME_ADDRESS] = "Aynı Adres";
translations[DRUG_BEING_USED] = "Olay sırasında bir Baxter ilacı kullanılıyor muydu?";
translations[PATIENT_IDENTIFIER] = "Hasta Kimliği";
translations[PATIENT_AGE_OR_DOB] = "Hasta Yaşı veya DOB";
translations[ENTER_PATIENT_AGE] = "aa / gg / yyyy, Hasta Yaşını Giriniz";
translations[PATIENT_GENDER] = "Hasta Cinsiyeti";
translations[PATIENT_WEIGHT] = "Hasta Ağırlığı";
translations[ENTER_WEIGHT] = "Ağırlık giriniz";
translations[PATIENT_WEIGHT_UNIT] = "Hasta Ağırlık Birimi";
translations[MY_NAME] = "Adım";
translations[ENTER_IN_YOUR_CONTACT] = "İletişim bilgilerinizi giriniz";
translations[MY_PHONE_NUMBER] = "Telefon Numaram";
translations[MY_EMAIL_ADDRESS] = "E-posta Adresim";
translations[MY_ADDRESS] = "Adresim";
translations[NAME_OF_BAXTER_DRUG] = "Baxter İlacının Adı";
translations[ENTER_DRUG_NAME] = "İlaç adını giriniz";
translations[PLEASE_PROVIDE_THE_NAME] = "Lütfen Baxter İlacının adını veya ürün kodunu belirtin. Bildirilen sorun sırasında kullanılmakta olan tüm Baxter ilaçlarının adını verin";
translations[SELECT_THE_COMPONENT] = "Sorunu olan bileşeni seçiniz";
translations[USE_THE_DIAGRAM] = "Hasarlı tek kullanımlık ürünün yerini belirlemek için yukarıdaki diyagramı kullanınız (Şekil 1).";
translations[TYPE_OF_DAMAGE] = "Lütfen hasar türünü açıklayınız";
translations[PLEASE_ENTER_VALUE] = "Lütfen değeri giriniz";
translations[WAS_THE_PRODUCT_KINKED] = "Ürün bükülmüş, çatlamış, katlanmış, kesilmiş vb. miydi?";
translations[WERE_ANY_CLEANING] = "Üründe herhangi bir temizleme solüsyonu, çözücü veya dezenfektan kullanılmış mı?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Dezenfektanın adı / markası neydi ve nasıl kullanıldı?";
translations[NOTE_BAXTER_LABELING] = "Baxter etiketinde sete ağartıcı, hidrojen peroksit, alkol veya antiseptik içeren alkol uygulanmaması gerektiğini belirtmektedir. Bu ürünlerin kullanılması üründe çatlaklara neden olabilir.";
translations[SELECT_ALL_THAT_APPLY] = "Geçerli olanların tümünü";
translations[DID_FOLLOWING_OCCUR] = "Aşağıdakilerden biri meydana geldi mi?";
translations[SELECT_THE_LOCATION] = "Mini Kapakta hasar olan yeri seçiniz";
translations[WAS_THE_PRODUCT_EXPOSED] = "Ürün, sorun oluşmadan önce herhangi bir aşırı kuvvete (yani vb.) maruz kaldı mı?";
translations[HOW_LONG_TRANSFER] = "Transfer set ne zamandır kullanılıyor?";
translations[WAS_THERE_DIFFICULTY] = "Döner başlıklı klembi açarken veya kapatırken herhangi bir zorluk oldu mu?";
translations[WAS_DEVICE_OR_TOOL] = "Transfer setin klembini açmak veya kapatmak için bir cihaz veya alet kullanıldı mı?";
translations[DESCRIBE_HOW_PRODUCT] = "Ürünün kullanımının nasıl zor olduğunu açıklayınız (uygun olan hepsini seçiniz)";
translations[DID_YOU_OBSERVE] = "Üründe herhangi bir hasar (örneğin kesik, delik, çatlak) gözlemlediniz mi?";
translations[WERE_DIFFICULTIES_PUTTING] = "Mini Kapağı Transfer Setine takmakta ve sağlam bir şekilde sabitlenene kadar saat yönünde çevirmekte herhangi bir zorluk var mıydı?";
translations[WAS_THE_TRANSFER] = "Bu olay nedeniyle transfer set değiştirildi mi?";
translations[SELECT_TYPE_OF_FLOW] = "Akış sorunu türünü seçin";
translations[WAS_ANYTHING_BLOCKING] = "Akışı engelleyen bir şey var mıydı?";
translations[WAS_ANY_ALARM] = "Alarm var mıydı?";
translations[SELECT_BEST_DESCRIBE] = "Sorunu en iyi açıklayan seçeneği belirleyin";
translations[WERE_THE_MINICAPS] = "Minikapaklar sıcak/soğuk ortama maruz kaldı mı?";
translations[WAS_THE_SPONGE_VISIBLE] = "Mini Kapağın içindeki sünger görünür müydü?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Partikül madde / yabancı madde nerede bulunuyordu?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Partikül madde / yabancı maddenin tam yerini, boyutunu, şeklini ve rengini açıklayınız:";
translations[WAS_THE_PARTICULATE_MATTER] = "Partikül madde / yabancı madde ürüne gömülü müydü?";
translations[DOES_THE_PARTICULATE_MATER] = "Partikül madde / yabancı madde ürün malzemesinin parçası gibi mi görünüyordu?";
translations[WHAT_COMPONENT_DOES] = "Parçacık hangi bileşendedir?";
translations[SELECT_CONNECTION_ISSUE] = "Bağlantı sorununu en iyi açıklayan seçeneği belirleyiniz";
translations[WERE_ASSIST_DEVICES] = "Tek kullanımlık ürünlerin bağlantısını yapmak için herhangi bir yardımcı cihaz veya araç kullanıldı mı?";
translations[WERE_ANY_DIFFICULTIES] = "İlk bağlantı sırasında veya bağlantı kesilme aşamasında herhangi bir zorluk fark edildi mi?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Bağlantı sorununda yer alan ikinci ürünün ürün bilgilerini sağlayınız";
translations[WERE_THE_SPIKE_LUER] = "Sivri uç / uç konektörleri sıkıca sabitlenene kadar saat yönünde döndürüldü mü?";
translations[BAXTER_LABELING_STATES] = "Baxter etiketinde, tedaviye başlamadan önce tüm tek kullanımlık set bağlantılarının güvenli ve uygun olduğundan emin olunması gerektiği belirtilmektedir. ";
translations[WERE_PETS_OR_ANIMALS] = "Tek kullanımlık sete zarar verebilecek herhangi bir evcil hayvan veya hayvan var mıydı?";
translations[BAXTER_LABELING_CONTAMINATION] = "Baxter etiketinde, bir evcil hayvan veya bir hayvanın tek kullanımlık malzemeleri ısırması durumunda solüsyonun geçtiği kateter hortumlarının kontaminasyonunun meydana gelebileceğini belirtilmektedir. Bu riski azaltmak için evcil hayvan veya hayvanlarla aynı odada diyaliz yapmayın.";
translations[WERE_OTHER_ISSUES] = "Sivri uç / uç ile ilgili başka sorunlar veya zorluklar var mıydı (yani çatlamış, deforme olmuş, bükülmüş vb.)?";
translations[WAS_MINICAP_TWISTED] = "Mini kapak, sıkıca sabitlenene kadar transfer seti konektörüne saat yönünde döndürüldü mü?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Transfer Set ile Mini Kapağı birleştirmekte zorluk var mıydı?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Transfer seti konektörlerinde dişlerde görünür bir hasar veya kalıntı var mıydı?";
translations[WHAT_WAS_THE_ALARM] = "Alarm neydi?";
translations[WHERE_OBSERVED_DAMAGE] = "Gözlenen hasar neredeydi (geçerli olanı seçiniz)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Gözlenen hasarın türünü seçin (geçerli olanların tümünü seçiniz):";
translations[DID_DAMAGE_CAUSE_LEAK] = "Hasar sızıntıya neden oldu mu?";
translations[WAS_THE_SHIPPING_CARTON] = "Nakliye kutusu keskin bir cisimle mi açıldı?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Gözlemlenen akış sorunu türünü seçiniz";
translations[HOW_LONG_WAS_STORAGE] = "Süresi dolmuş ürün bulunmadan önce ne kadar süre depodaydı?";
translations[WAS_THERE_AN_ADAPTER] = "Ürünle birlikte kullanılan bir adaptör veya başka bir aygıt (lar) var mıydı?";
translations[NAME_AND_MODEL] = "Adaptör veya kullanılan başka bir aygıtın adı ve modeli nedir?";
translations[NAME_VAPORIZER] = "Buharlaştırıcının adı ve modeli nedir?";
translations[WAS_VIAL_INVERTED] = "Çözeltinin şişeye sıkılmasından önce ekli şişe ters çevrildi mi?";
translations[WHAT_VIAL_USED] = "Kullanılan şişe için ürün bilgisi nedir?";
translations[DRUG_NAME_MANUFACTURER] = "İlaç adı, üretici, flakon boyutu:";
translations[WERE_BREAK_FRANGIBLE] = "İleri geri bir hareketle kilidi düzgün bir şekilde kırabildiniz mi?";
translations[WAS_ALARM_ASSOCIATED] = "Akış olmaması ile ilgili herhangi bir alarm var mıydı?";
translations[WHAT_PART_DISCOLORED] = "Ürünün hangi kısmında renk değişimi olduğu bildirildi? (uygun olan her şeyi seçiniz)";
translations[DESCRIBE_DISCOLORATION] = "Renk değişikliğini tanımlayın (renk, renk tonu, gölge vb. tanımlayınız):";
translations[HOW_PRODUCT_STORED] = "Ürün nasıl depolandı?";
translations[DOES_DISCOLORATION_APPEAR] = "Renk değişikliği opak, puslu, bulanık ve/veya dairesel/petek işaretleri var gibi mi görünüyordu?";
translations[WHICH_CHAMBER_DISCOLORED] = "Torbada hangi bölümde renk değişikliği vardı?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "Mühür veya bölmeler arası bölge zaten aktive edilmiş/etkinleştirilmiş miydi?";
translations[WAS_DISCOLORATION_NOTICED] = "Renk değişikliği buharlaştırıcı gözetleme camından fark edildi mi?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Sorunu daha ayrıntılı olarak açıklayan seçeneği belirleyiniz:";
translations[WHAT_DEVICE_HAD_ALARM] = "Hangi cihazda alarm vardı?";
translations[WHAT_MISSING_MISASSEMBLED] = "Hangi bileşen eksik veya yanlış monte edildi?";
translations[RECONSTITUTION_ISSUE] = "Karıştırma probleminin daha spesifik bir açıklamasını sağlayınız";
translations[WHAT_MEDICATION_SOLUTION] = "Ürün hangi ilaç / solüsyonla karıştırıldı?";
translations[WHAT_VOLUME_MEDICATION] = "Karıştırma için kullanılan ilaç / çözelti hacmi neydi?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Karıştırma sırasında başka hangi cihazlar kullanıldı (isim / üretici, iğne boyutu / ölçer, vb.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Ürün ısıya maruz kaldı mı?";
translations[DESCRIBE_EXPOSURE] = "Maruz kalmayı (sıcaklık, ne kadar süre vb.) Açıklayınız";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Solüsyonu etkinleştirmek için hangi teknik kullanıldı?";
translations[WAS_DAMAGE_OBSERVED] = "Aktivasyondan önce üründe herhangi bir hasar gözlendi mi?";
translations[DESCRIBE_THE_DAMAGE] = "Hasarı açıklayınız:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Yaklaşık olarak, ne kadar çözelti veya toz az doldurulmuş veya fazla doldurulmuştur?";
translations[WAS_LEAK_OBSERVED] = "Sızıntı gözlemlendi mi?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Ürünün hangi bileşeninin veya özelliğinin kullanılması zordur?";
translations[HOW_WAS_DIFFICULT_USE] = "Ürünün kullanılması nasıl zordu?";
translations[WHERE_MATTER_FOREIGN] = "Partikül madde / yabancı madde nerede bulunuyordu?";
translations[DOES_PARTICULATE_MATTER] = "Partikül madde / yabancı madde ürün malzemesi parçaları gibi mi görünüyordu?";
translations[DESCRIBE_EXACT_LOCATION] = "Partikül madde/yabancı maddenin tam yerini, rengini, boyutunu, şeklini ve dokusunu açıklayınız:";
translations[WAS_MATTER_FOREIGN] = "Partikül madde / yabancı madde ürüne gömülü müydü (serbestçe hareket etmiyor muydu)?";
translations[WHEN_MATTER_FOREIGN] = "Partikül madde / yabancı madde ne zaman gözlendi?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Eklenen ilaç için ürün bilgisi sağlayınız:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Ürün adı, ürün kodu, ürün lot numarası, Marka Adı";
translations[DESCRIBE_SPIKING] = "Kullanılan delme veya karıştırma tekniğini açıklayınız:";
translations[INCLUDE_NEEDLE] = "İğne boyutunu/gauge, iğne giriş/delme açısını, deneme sayısını dahil ediniz";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Hangi uygulama seti veya karıştırma cihazı kullanıldı?";
translations[INCLUDE_MANUFACTURER] = "Üreticiyi, ürün adını, ürün kodunu, ürün lotunu dahil ediniz";
translations[WAS_MEDICATION_ADDITIVE] = "Ürüne bir ilaç, katkı maddesi veya karıştırmaçözeltisi eklendi mi?";
translations[WHAT_MEDICATION_ADDITIVE] = "Hangi ilaç, katkı maddesi veya karıştırma çözeltisi eklendi?";
translations[WHAT_STATE_OF_PRODUCT] = "Bulanıklık / çökelti gözlendiğinde ürünün durumu nedir?";
translations[AFTER_UNITS_SAT] = "Üniteler yerleştirildikten ve oda sıcaklığına ulaştıktan sonra bulanıklık / çökelti gitti mi?";
translations[DID_ATTEMPT_AGITATE] = "Birimi sallama girişiminiz oldu mu?";
translations[DID_PRECIPITATE_DISSOLVE] = "Çökelti çözüldü mü?";
translations[WHAT_STORAGE_TEMPERATURE] = "Ürün depolama sıcaklığı ve koşulları nelerdi?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Dış torba/karton, VSC/Ara karton, ayrı birimlerin içinde veya dışında depolanan sıcaklık ve lokasyon bilgisini veriniz.";
translations[ARE_TEMPERATURE_LOGS] = "Ürünün depolandığı dondurucu (lar) için sıcaklık kayıtları mevcut mu?";
translations[LOGS_CAN_BE_ATTACHED] = "Bildirim esnasında, cihaz kayıt günlükler mevcutsa doğrudan bu forma eklenebilir";
translations[IS_THE_STORAGE_UNIT] = "Depolama ünitesi (dondurucu veya buzdolabı) kalibre edilmiş ve sıcaklık kontrollü mü?";
translations[HOW_PRODUCT_THAWED] = "Ürün nasıl eridi?";
translations[WHAT_STORAGE_CONDITIONS] = "Ürünün saklama koşulları nelerdir? (sıcaklık, konum, dış torba/karton içinde veya dışında saklanan)";
translations[WAS_ANY_DAMAGE] = "Üründe herhangi bir hasar veya sorun gözlendi mi?";
translations[MORE_SPECIFIC_INFORMATION] = "Lütfen daha ayrıntılı bilgi veriniz:";
translations[WHAT_PURPOSE_INDICATION] = "Hasta için tedavinin amacı / endikasyonu nedir?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Uygulama yolu nedir?";
translations[WHAT_DATE_ADMINISTRATION] = "Uygulama tarihi ve süresi nedir?";
translations[WHAT_DOSAGE_STRENGTH] = "Hastaya uygulanan dozaj / miktar neydi?";
translations[WAS_RECENT_PRESCRIPTION] = "Yeni bir reçete değişikliği oldu mu?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Ürünün depolama / sıcaklık detayları nedir (depolama konumu / buzdolabı / derin dondurucu vb.)?";
translations[WERE_ANY_ADJUSTMENTS] = "Uygulamadan önce çözelti veya katkı maddelerinde herhangi bir ayarlama yapıldı mı?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Sorunun en uygun açıklamasını seçiniz:";
translations[SELECT_LABELING_ISSUE] = "Etiketleme sorununun en uygun açıklamasını seçiniz:";
translations[WAS_CONNECTION_SECURE] = "Bağlantı güvenli ve tamamen sıkıldı mı?";
translations[WAS_EXPIRED_PRODUCT] = "Süresi dolmuş ürün hastaya verildi mi??";
translations[WAS_COMPONENT_DAMAGED] = "Herhangi bir bileşen hasar gördü mü?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Üründe herhangi bir anormallik / hasar fark edildi mi?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Satınalma siparişi numaranız nedir?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Uygulama tarihi nedir?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Ürünün son kullanma tarihi nedir?";
translations[DESCRIBE_WAS_INCORRECT] = "Etikette neyin yanlış, eksik, eksik, okunaksız olduğunu veya etikette neyin çok benzer olduğunu (başka bir ürüne) açıklayınız:";
translations[WHAT_SCANNER_USED] = "Ne tür bir tarayıcı kullanıldı?";
translations[WAS_OVERPOUCH_POUCH] = "Tarama sırasında ürün hala dış torba / torba içinde miydi?";
translations[WHAT_BACKGROUND_COLOR] = "Tarama yaparken arka plan ne renkti?";
translations[DO_ALL_OF_THE_LABELS] = "Tüm etiketler (ürün, kutu / karton, nakliye / dağıtım) aynı ürün bilgilerine sahip mi?";
translations[PRODUCT_INFORMATION] = "Ürün Bilgileri";
translations[IS_A_BARCODE_SCANNER] = "Tesisinizde bir barkod tarayıcı kullanılıyor mu?";
translations[HOW_ARE_THESE_PRODUCTS] = "Bu ürünler tesiste nasıl depolanıyor?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Tarandığında hangi bilgiler yanlış görüntülendi?";
translations[WAS_THERE_LEAK] = "Sızıntı veya nem gözlemlendi mi?";
translations[WHERE_LEAK_OBSERVED] = "Sızıntı nerede görüldü, hangi bileşen sızdırıyordu?";
translations[WAS_FRANGIBLE_OBSERVED] = "Kilit kırık olarak mı gözlemlendi?";
translations[IS_MOISTURE_CLEAR] = "Nem berrak mıydı?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Distribütörünüz kimdir?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Kullanılan flakonun üreticisi, ilaç adı ve boyutu nedir?";
translations[WHAT_GAUGE_NEEDLE] = "Kullanılan iğnenin ölçüsü, üreticisi ve alanın delinme sayısı nedir?";
translations[WHAT_ADMINISTRATION_SET] = "Hangi uygulama seti kullanıldı?";
translations[WAS_DIFFICULTY_SPIKING] = "Delme zorluğu var mıydı?";
translations[WERE_FOLLOWING_SCENARIOS] = "Sızıntıda aşağıdaki senaryolardan herhangi biri oluştu mu?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Kilidin hasar veya kusuru olduğu gözlemlendi mi?";
translations[WHAT_AMOUNT_PRESSURE] = "Ne kadarsüreyle ne kadar basınç uygulandı?";
translations[WAS_BAG_COMPLETELY] = "Torba tamamen ve doğru bir şekilde basınç koluna yerleştirildi mi (bir ucu basınç kolunun dışında mıydı)?";
translations[WHAT_MANUFACTURER_MODEL] = "Basınç kolunun üreticisi, modeli ve boyutu nedir?";
translations[WHAT_PRESSURE_PRIOR] = "Sızıntı tespit edilmeden önceki basınç neydi?";
translations[LIST_THE_VAPORIZER] = "Buharlaştırıcı üreticisini ve adını / modelini listeleyiniz";
translations[APPROXIMATELY_HOW_MUCH] = "Yaklaşık olarak ne kadar sıvı döküldü?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "Şişenin buharlaştırıcıya yerleştirilmesi zor muydu?";
translations[WERE_VISIBLE_DEFECTS] = "Görünür bir kusur var mıydı?";
translations[SELECT_THE_OPTION] = "Bağlantı sorununu en iyi açıklayan seçeneği belirleyiniz";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Bağlantı sorununda yer alan ikinci ürünün ürün bilgilerini sağlayınız";
translations[WHICH_PART_SEPARATED] = "Ürünün hangi parçaları ayrıldı?";
translations[WHAT_COMPONENT_DISCOLORED] = "Hangi bileşen in rengi değişmiştir?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Renk değişikliğini en iyi tanımlayan seçeneği belirleyiniz:";
translations[WAS_THE_SET_DISCOLORED] = "Paketten çıkarıldığında setin rengi farklı mıydı?";
translations[DID_SET_CHANGE_COLOR] = "İlaç ekledikten sonra set renk değiştirdi mi?";
translations[WHAT_MEDICATION_ADDED] = "Renk değişiminden önce hangi ilaç eklendi?";
translations[WHERE_MATERIAL_LOCATED] = "Partikül madde / yabancı madde nerede bulunuyordu?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Partikül madde / yabancı maddeyi tanımlayınız (görünüm / renk / boyut):";
translations[WAS_EMBEDDED_PLASTIC] = "Yabancı madde/ partikül  gevşek veya plastiğe gömülü müydü?";
translations[WAS_THERE_A_PRECIPITATE] = "İnfüzörde / çözeltide beklenmeyen renk değişikliği veya çökelti oldu mu?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Set ile hangi ilaçlar / solüsyonlar infüze edildi?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Hasar neredeydi veya hangi bileşen (ler) etkilendi (geçerli olanları seçiniz)?";
translations[WHAT_DAMAGE_ISSUE] = "Ne tür bir hasar / sorun gözlendi (geçerli olanı seçiniz)?";
translations[DID_ISSUE_RESULT] = "Bu sorun sızıntıya neden oldu mu?";
translations[WAS_PATIENT_CONNECTED] = "Hasta ürüne bağlı mıydı?";
translations[WAS_PRODUCT_REPLACED] = "Ürün yeni bir ürünle değiştirildi mi?";
translations[WHICH_SITUATION_BEST] = "Ayrılma / Bağlantı Sorununu en iyi açıklayan durum hangisidir?";
translations[SELECT_MOST_LABELING_ISSUE] = "Etiketleme sorununun en uygun açıklamasını seçiniz:";
translations[WHAT_INFORMATION_DISPLAYED] = "Hangi bilgiler görüntülendi?";
translations[WHAT_SCANNER_WAS_USED] = "Ne tür bir tarayıcı kullanıldı?";
translations[INCLUDE_THE_MODEL_NAME] = "Model adını ekleyiniz";
translations[WAS_PRODUCT_ORDERED] = "Ürün doğrudan Baxter'dan mı yoksa başka bir distribütörden mi sipariş edildi?";
translations[WHERE_LEAK_COMING] = "Sızıntı nereden geliyordu (geçerli olanı seçiniz)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Sızıntı ile aşağıdaki senaryolardan herhangi biri oluştu mu?";
translations[WAS_POWER_INJECTOR] = "Ürün bir güç enjektörüyle mi kullanıldı?";
translations[WHAT_INJECTOR_USED] = "Hangi güç enjektörü kullanıldı?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Üretici, ürün adı, ürün kodu, ürün lotu";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Etikette neyin yanlış, eksik, eksik, okunaksız veya değiştirilmiş olduğunu açıklayınız:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Bağlantı kopmasına dahil olan ikinci ürünün ürün bilgilerini sağlayınız:";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Hangi bileşenlerin çatlak veya kırık olduğu bulundu?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Hatta kesik, delik veya parçalamanın tam yerini belirtiniz: ";
translations[WAS_LEAK_ORIGINATING] = "Sızıntı enjeksiyon bölgesi açıklığından mı kaynaklandı";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Bağlantı kopması / bağlantı sorununda yer alan ikinci ürünün ürün bilgilerini sağlayınız";
translations[WHICH_SPECIFIC_BONDED] = "Hangi spesifik bağlı bileşenlerin ayrıldığı gözlemlendi?";
translations[WERE_VISIBLE_IRREGULARITIES] = "İlgili ürün/bileşenler üzerinde görünür herhangi bir düzensizlik/hasar var mıydı?";
translations[WAS_SUCCESSFUL_CONNECTION] = "Sonunda başarılı bir bağlantı veya bağlantı kesilmesi yapıldı (ürünü değiştirmek zorunda kalmadan)?";
translations[WAS_TOOL_USED_ASSIST] = "Bağlantı / bağlantı kesilmesine yardımcı olmak için bir araç kullanıldı mı?";
translations[WERE_LUER_CONNECTIONS] = "Tüm uç bağlantılar, kullanımdan önce güvenli olduklarından emin olmak için kontrol edildi mi (etikete göre)";
translations[WAS_PRODUCT_SECURELY] = "Bağlantıyı kesmeden önce ürün başka bir ürünle güvenli bir şekilde bağlandı mı?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Akış Sorununu en iyi hangi durum açıklar?";
translations[WHAT_FLOWING_BACKWARDS] = "Geriye doğru akan neydi?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Geri akışın başladığı yerden durduğu yere kadar olan bileşenleri açıklayınız:";
translations[DO_SITUATIONS_APPLY] = "Bu durumlardan herhangi biri bu olay için geçerli midir?";
translations[WHICH_SPECIFIC_AREA] = "Setin spesifik hangi bölgesi veya bileşeni akış sorunu ile ilişkiliydi? ";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Akış daha önce set veya bileşen üzerinden görüldü mü?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Aşağıdakilerden herhangi biri gözlemlendi mi:";
translations[WHERE_SIMULTANEOUS_FLOW] = " Eşzamanlı Akış neyin arasındaydı? ";
translations[WHAT_TYPE_HANGER] = "Ne tür bir askı kullanıldı?_x000D_";
translations[WHAT_WAS_HANGER_LENGTH] = "Askı uzunluğu ve / veya üreticisi neydi?";
translations[WHICH_BAG_LOWER] = "Hangi torba daha aşağıdaydı?";
translations[WHAT_Y_SITE_WAS] = "İkinci set hangi y-bölgesiyle bağlantılıydı?";
translations[WHAT_COMPONENT_WITHIN] = "Setin içindeki hangi bileşen çözelti veya kandan temizlenemiyor?";
translations[WAS_COMPONENT_SET_REPLACED] = "Temizlenemedikten sonra bileşen / set değiştirildi mi?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Hastaya infüze edilecek sıvı hacmi ve öngörülen süre neydi?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Hastaya infüze edilen asıl sıvı hacmi ve süre nedir?";
translations[WAS_USED_WITH_PUMP] = "Set pompayla mı kullanıldı?";
translations[DID_CLAMP_FAIL] = "Bir klemp akışı durduramadı veya kontrol edemedi mi?";
translations[WHAT_CLAMP_FAILED] = "Hangi klempte sorun oldu?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Klemple ilgili herhangi bir sorun var mıydı?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Bu diğer durumlardan herhangi biri ürün sorununu açıklar mı (geçerli olan her şeyi seçiniz)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Gözlemlenen alarmı açıklayınız:";
translations[INCLUDE_ANY_MESSAGES] = "Alarmla ilişkili tüm mesajları ve hata kodlarını ekleyiniz";
translations[WHICH_CLAMP_HAD_ISSUE] = "Hangi klembin sorunu vardı?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Ne tür bir klemp sorunu yaşandı (geçerli olanı seçiniz)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Sorunu en iyi açıklayan senaryoyu seçiniz:";
translations[PROVIDE_MORE_DETAILS] = "Ürünün kullanımının neden zor olduğu hakkında daha fazla ayrıntı sağlayınız:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Takip etmesi/anlaması zor olan talimatlar hakkında daha fazla ayrıntı sağlayınız:";
translations[DESCRIBE_THE_SMELL] = "Kokuyu ve nereden geldiğini açıklayınız:";
translations[WAS_ISSUES_WITH_SET] = "Sette herhangi bir sorun var mıydı?";
translations[WHERE_LEAK_LOCATED] = "Üründeki sızıntı nerede bulunuyordu?";
translations[DID_OCCUR_WITH_LEAK] = "Sızıntı ile birlikte aşağıdakilerden herhangi biri meydana geldi mi?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Bağlantı kopmasına dahil olan ikinci ürünün ürün bilgilerini sağlayınız:";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Sızıntı ile aşağıdaki senaryolardan herhangi biri oluştu mu?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Ürün nerede hasar gördü?";
translations[SELECT_ALL_APPLY] = "Geçerli olanların tümünü";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Gözlenen hasarı tanımlayınız";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Ürünün hangi bileşeninde renk değişimi olmuştur?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Gözlemlenen rengi ( ton, renk tonu, gölge vb.) Tanımlayınız:";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "İç veya dış poşet, sıcaklık, ışığa maruz kalma vb.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Partikül madde / yabancı maddenin tam yerini, boyutunu, şeklini ve rengini açıklayınız:";
translations[DOES_THE_PARTICULATE_MATTER] = "Partikül madde / yabancı madde ürün malzemesi gibi mi görünüyordu? ";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Partikül madde / yabancı madde ürüne gömülü müydü?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Partikül madde / yabancı madde ürün malzemesinin parçası gibi mi görünüyordu?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Ürünün neresinde sorun oluştu?";
translations[LIST_COMPONENTS_IF] = "Bileşenleri listeleyiniz. Eğer ikinci bir ürün mevcutsa, Üretici, Ürün adı, Ürün Kodu, Ürün lotunu belirtiniz. ";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Görünür düzensizlikler / hasarlar var mıydı?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Akış sorununu en iyi açıklayan seçeneği belirleyiniz:";
translations[DESCRIBE_IRREGULARITIES] = "Düzensizlikleri / hasarları tarif ediniz ve hasarın bağlantı / bağlantı kesilmesi sırasında veya öncesinde olup olmadığını belirtiniz. ";
translations[HOW_PRODUCT_SETUP] = "Ürün kurulumu nasıldı?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Etiketleme sorununun en uygun açıklamasını seçiniz:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Etikette neyin yanlış, eksik, eksik, okunaksız olduğunu veya etikette neyin çok benzer olduğunu (başka bir ürüne) açıklayınız:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Nakliye kartonundaki ürün hasar gördü mü?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Hangi ürünün alınması gerekiyordu?";
translations[IF_PRODUCT_CODE_NOT] = "Ürün kodu mevcut değilse, lütfen ürün açıklamasını sağlayınız";
translations[WAS_THE_CASE_MISSING] = "Kasada kuru buz veya soğutulmuş jel paketleri eksik miydi?";
translations[WHAT_CARRIER_DELIVERED] = "Ürününüzü hangi taşıyıcı teslim etti?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Satınalma siparişi numarası nedir?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Kayıp birim sayısı nedir?";
translations[WAS_EXPIRED_PRODUCT_USE] = "Son kullanma tarihi geçmiş ürün kullanılmış mı?";
translations[APPLY_TO_EACH_UNIT] = "Bu sorun birden fazla ünitede meydana geldiyse aşağıdaki sorular her ünite için geçerlidir.";
translations[TERMS_CONDITIONS] = "Şartlar ve Koşullar";
translations[PRIVACY_POLICY] = "Gizlilik Politikası";
translations[PRIVACY_NOTICE] = "Gizlilik Bildirimi";
translations[COOKIE_POLICY] = "Çerez politikası";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Soruldu, bilinmiyor";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "Baxter Çalışanı";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Bakıcı";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distribütör";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Sağlık çalışanı";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Hasta";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Diğer";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Kullanım Sonrası";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Kullanım Öncesi";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Kurulum/Hazırlık/Birleştirme Sırasında";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Tedavi Sırasında";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Birden fazla aşamada";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Belirtilmemiş";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Aile üyesi";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Hemşire";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Pratisyen hemşire";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Diğer Sağlık Uzmanı";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Doktor";
translations[OPTION_UNITOPTIONS_BOXES] = "Kutular";
translations[OPTION_UNITOPTIONS_PALLETS] = "Paletler";
translations[OPTION_UNITOPTIONS_UNITS] = "Birimler";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Alarm Durumu";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Hasar";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Kullanım Zorluğu";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Renk Değişimi";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Akış Sorunu";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Etiketleme Sorunu";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Sızıntı / Aşırı Nem";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Partikül Madde / Yabancı Madde";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Hasta Reaksiyonu / Advers Olay";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Ürün Sorgusu";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Ayrılma / Bağlantı";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Taşıma Sorunları / Süresi Dolmuş Ürün";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Kadın";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "farklılaşmamış";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Erkek";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Yanıtlamayı reddet";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Yönetici/Süpervizör";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Biyomedikal mühendisi";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Şirket temsilcisi";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Diş doktoru";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distribütör";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Aile üyesi";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "İlk Kullanıcı";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Hemşire";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Pratisyen hemşire";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Diğer Sağlık Uzmanı";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Eczacı";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Eczane Teknisyeni";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Doktor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Hasta";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Risk Yöneticisi";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Diğer";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Başka biriyle iletişime geçiniz";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Bana ulaşın";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Başka biriyle iletişime geçin";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "Baxter";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "Çin FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Sağlık Kanada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japonya)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TÜV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Avustralya)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Bir evcil hayvan veya hayvan soruna neden olmuş olabilir";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Kartonu veya dış torbayı açmak için keskin bir nesne veya obje kullanıldı";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Ürün, sorun oluşmadan önce aşırı kuvvete (yani çarpma, vurma vb.) Maruz kaldı";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "Ürün sıcak / soğuk bir ortama maruz bırakıldı veya saklandı.";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Karton";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minikapak";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Torba";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "Transfer seti çok sıkıydı";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "Transfer seti çok gevşekti.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "Transfer seti tamamen kapatılamadı";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "Transfer setii tamamen açılamadı";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "Döner başlıklı klemp o kadar sıkıydı ki transfer seti hiç açılamadı";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "Döner başlıklı klemp o kadar sıkıydı ki transfer seti hiç kapanamadı";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Evet -transfer setinin dişlerinin düzgün şekilde kapanmasını engelleyen hasar / yanlışlık vardı";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Evet -Minikapak, elle veya bir alet / yardımcı cihazla transfer setine fazlaca sıkıldı";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Hiç sıvı akışı olmadan tamamen durdu";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Kısıtlı veya Kısmen akış (yavaş akış)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Pıhtılaşmış Kan";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrin";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Kıvrılma";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Partikül";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Ürün Malzemesi";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Bağlantı sırasında veya ambalajda tespit edilen fazla iyot (kahverengi)";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Ambalajda gözlemlenen fazla nem (berrak damlacıklar)";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Folyo kese açılmadan önce hasar görmüş";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Paket/kutu kullanmadan önce açık veya hasarlı";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Sünger kurumuş ve beyaz";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Sünger kahverengimsi bir renkte ve kurumuş";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "İkincil ambalajda / dış torbada";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Ürün / sıvı yolunun içinde";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Nakliye kartonunun içinde";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Ürünün dış tarafında";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "İkincil ambalajın dış tarafında / dış torbada";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Kargo kartonunun dış tarafında";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Ürünü başka bir ürüne bağlamada zorluk";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Ürünün başka bir ürünle bağlantısını kesmede zorluk";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Tek bir üründeki bileşenlerin ayrılması";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Ürünün başka bir üründen ayrılması / bağlantı kopması";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "EVET - dişlerde kalıntı";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "EVET - görünür hasar";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Evet - Diğer (Serbest Metin)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Kilit";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Askı Deliği";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Enjeksiyon / Dolum Portu";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Membran Bağlantı Noktası";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Dış torba / torba üzerinde";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Yama";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Kauçuk Tıpa";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Nakliye kartonu";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Çekme bandı";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "solüsyon kabı";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Uç Koruyucu";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Sıkmaya dayanıklı conta (streç film)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Bükülmüş";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Kırılmış";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Çatlak";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Kesik";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Deforme olmuş";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Pullanmış";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Delinmiş";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Kıvrılmış";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Erimiş";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Yama Katmanı Ayrılmış";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Parçalanmış (cam)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Kesilmiş";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Yırtık";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "Solüsyon hiç akmayacaktır";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "Solüsyon çok yavaş akacaktır";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "Solüsyonu karıştırma ya da birleştirme sırasında akış olmaz ( (ya da yavaş akış olur)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Şişe";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Kutu";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Askı Deliği";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Kaplama maddesi";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Dış torba / torba üzerinde";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Oksijen göstergesi";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Yama";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Bağlantılar";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Solüsyon";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Uç Koruyucu";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Amino Asit Haznesi";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Dekstroz Haznesi";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Lipid Haznesi";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Alt Hazne";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Üst Hazne";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Patlamış / Yırtılmış Mühür";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Hatalı birleştirilmiş ürün/parça";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Eksik Bileşen";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Bağlı Bileşen (ler) in Ayrılması / Bağlantı kopması";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Fazla doldurulmuş ürün";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Az Doldurulmuş Ürün";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Karıştırma Sorunu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "İkincil ambalajda / dış torba";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Nakliye kartonunun içinde";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "Nakliye kartonunun dış tarafında";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Solüsyon içi / sıvı yolu";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "Buharlaştırıcı hazenin içinde (gözlem camı)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Ürünün dış yüzeyinde";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "İkincil ambalajın dış tarafında / dış torba";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "Oksijen emici üzerinde";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Transdermal yama üzerinde";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Kilit";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Cam Parçacıkları";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Port";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Kauçuk tıpa";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Hat";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Başka bir ilaç ekledikten sonra veya karıştırıldıktan sonra (flakon)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Delme veya karıştırmadan önce";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Soğuk (çözülmüş ama henüz oda sıcaklığında değil)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Dondurulmuş";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Kısmen çözülmüş (solüsyonda buz kristalleri)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Oda sıcaklığı";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "Baxter Çözdürme Ünitesi (BTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Oda sıcaklığında tezgahta bırakılır";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Buzdolabı";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Evet - nakliye sırasında hasar olduğuna dair kanıtlar vardır";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Evet - bir sızıntı gözlemlendi";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Evet - dış torbada bir delik veya tamamlanmamış mühür vardır";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Evet - delme veya karıştırma zorluğu vardır";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Evet - kilidi kırmakta zorluk vardır";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Evet - solüsyonun kristalleşmesi veya çökelmesi oldu";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Evet - Donmuş Galaksi ürününde bulanıklık / çökelti vardır";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Ürün amaçlanan etkiyi sağlamadı veya etkisizdi (etkisizlik)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "İstenmeyen etki / reaksiyon. Lütfen belirtiniz: (serbest metin)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Teslimat sırasında hasarlı nakliye kartonu";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "son kullanma tarihi geçmiş ürün teslim edildi";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "son kullanma tarihi geçmiş ürün bulundu";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barkod Sorunu - Tarandığında Görüntülenen Yanlış Bilgi";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Taranma zorlukları / taranamayan Barkod";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Son kullanma tarihi geçmiş ürün teslim edildi";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Envanterde son kullanma tarihi geçmiş ürün bulundu";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Okunaksız Etiket";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Yanlış etiket";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Tamamlanmamış Etiket";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Etiket başka bir ürüne çok benzer";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Etiketler (ürün, kutu / karton, nakliye listesi) aynı ürün bilgilerine sahip değildir";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Eksik Barkod";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Karton / kutu yanlış ürün veya karışık ürün içerir";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Teslimat sırasında hasarlı nakliye kartonu";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Fazladan ürün alındı";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Süresi dolmuş Ürün teslim edildi";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Süresi dolmuş Ürün bulundu";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Kartonun bir kısmı açık veya mühürlenmemiş";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Kartondaki ve dağıtım etiketindeki ürün bilgileri, kartonun içindeki ürünle eşleşmedi";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Ürünler eksikti";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Eksik Etiket";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Son kullanma Tarihi";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Lot Numarası";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "NDC Numarası";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = " dış torba içerisinde sızıntı gözlemlenmeden damlacıklar / nem vardır";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Sızıntı";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Torba sıkıldığında sızıntı meydana gelir";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Solüsyon, kilitten akıyor";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Dış torba içerisinde sızıntı gözlemlenmeden solüsyon vardır";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Dış torba ve birincil torba arasında";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "İki ürün arasındaki bağlantı";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Konteyner - Membran Bağlantı Noktası / Tüp";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Konteyner - Enjeksiyon / Dolum Portu";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Konteyner - Askı Deliği";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Kutu";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Kilit";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Kauçuk Tıpa";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Çekme bandı";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Uç Koruyucu";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Flakon Adaptörü";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Yapışmış Port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "İkincil ambalajda veya ara kartonda hasar (delikler, yırtılmalar)";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Aşırı sıcak / soğuğa maruz kalma";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Buharlaştırıcı arayüzünde sızıntı";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Bir kutu kesici / keskin nesne ile nakliye kartonunu açma";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Evcil hayvanlar (pençelenmiş / çiğnenmiş)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Çözüm basıncı kelepçesi ya da diğer cihaz ile baskı altında çanta";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Yapışmış kapak";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "İkincil ambalajda veya ara kartonda hasar (delikler, yırtılmalar)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Teslimat sırasında hasarlı nakliye kartonu";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Aşırı sıcak / soğuğa maruz kalma";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Buharlaştırıcı arayüzünde sızıntı";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Kesici / keskin nesne ile nakliye kartonunu açma";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Evcil hayvanlar (pençelenmiş / çiğnenmiş)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Çözüm basıncı kelepçesi ya da diğer cihaz ile baskı altında çanta";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Yukarıdakilerin hiçbiri";
translations[NO_DESCRIBE_THE_COLOR] = "Hayır- rengi tarif ediniz (serbest metin)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10 mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "10 mL'den fazla";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "1 mL'den az";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Şişe";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Kapak";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "vana/sap";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Hiçbiri";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Ürünü başka bir ürüne bağlamada zorluk";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Ürünün başka bir ürünle bağlantısını kesmede zorluk";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Tek bir üründeki bileşenlerin ayrılması";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Ürünün başka bir üründen ayrılması / bağlantı kopması";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Damlama Haznesi";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Hat";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Diğer - Lütfen belirtiniz (Serbest metin)";
translations[OTHER_PLEASE_SPECIFY] = "Diğer - Lütfen belirtiniz (Serbest metin)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Beyaz/Bulanık";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Sarı/Kahverengimsi";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Diğer-Lütfen belirtiniz (serbest metin)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "Birincil ambalajda / blister torbada";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "IV sıvı yolunun içinde (hatta)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Nakliye kartonunun içinde";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Nakliye kartonunun dış tarafında";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "IV Sıvı yolunun dışında (hattın dışında)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Gömülü";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Gevşek";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Uygulanabilir değil";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Rengi açıklayınız (serbest metin)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Evet - Renk Değişimi";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Evet - Çökelti";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Erişim bölgesi";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Cam Tüpler";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Klemp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Damlama Haznesi";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Hat";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filtre";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Uç Konektörü";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Sivri uç";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Kesik/Çatlak/Kırık Bileşen (ler)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Yanlış Bileşen Montajı - Lütfen belirtin (serbest metin)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Kıvrılmış / Yığılmış Bileşen (ler)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Ambalajın İçindeki Gevşek Bileşen (ler)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Kusurlu/Yanlış şekilli Bileşeni (ler)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Eksik Bileşen";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Ürünü başka bir ürüne bağlamada zorluk";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Ürünü başka bir üründen ayırmada zorluk";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Gevşek bağlantı";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Ürünün başka bir üründen ayrılması/bağlantısının kesilmesi";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Tek bir üründe birbirine bağlı iki bileşen arasındaki ayrılma";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "İki ürünün birbirine bağlanamaması";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "Ürünün başka bir ürünle bağlantısı kesilemiyor";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barkod Sorunu - Tarandığında Görüntülenen Yanlış Bilgi";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Etiketlemede Değişiklik";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Barkod tarama zorlukları/taranamayan Barkod ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Süresi dolmuş Ürün";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Etikette Yanlış Bilgi";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Barkod/UDI Eksik";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Etikette Eksik Bilgi";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Son kullanma tarihi olmayan ürün";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Lekeler / Okunamayan Etiketleme";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "Karton/kutu yanlış ürün veya karışık ürün içeriyor";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Teslimat sırasında hasarlı nakliye kartonu";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Süresi dolmuş Ürün teslim edildi";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Süresi dolmuş Ürün bulundu";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "Baxter";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "Distribütör";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Fazla ürün alındı";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Kutunun bir kısmı açılmış veya kapatılmamış";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Karton ve dağıtım etiketindeki ürün bilgileri, kartonun içindeki ürünle eşleşmiyor";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "ürünler eksikti";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Erişim bölgesi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Havalandırma";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Cam Tüpler";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Kapak";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink enjeksiyon bölgesi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Klemp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Damlama haznesi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filtreler";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink enjeksiyon bölgesi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Uç konektörü";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Sivri uç";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Hat";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Enjeksiyon bölgesi ve hat arasında sızıntı";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "İğne Tabanlı Enjeksiyon Bölgesi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "Tek Bağlantılı enjeksiyon bölgesi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Diğer enjeksiyon bölgeleri (Serbest Metin)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Sert set bileşenlerinde çatlak / kırılma";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Yumuşak hatta kesik / parçalanma";
translations[DISCONNECTION_OF_CONNECTABLE] = "Bağlanabilir bileşenlerin / bağlı ürünlerin bağlantısının kesilmesi";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Bağlanabilir bileşenlerin / bağlı ürünlerin bağlantısının kesilmesi";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Bağlı bileşenlerin ayrılması";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Evet - Düzensizlikleri / hasarları açıklayınız (serbest metin)";
translations[YES_SPECIFY_THE_TOOL] = "Evet - Kullanılan aracı belirtiniz (Serbest Metin)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Geri akış";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Klemp Arızası - Klemplenmesi Zor (ancak sonunda kapanabilir)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Klemp Arızası - Tamamen kapanamıyor";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Klemp Arızası - Zor / Açılamıyor";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Akış Yok";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Aşırı İnfüzyon";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Kısıtlı / Yavaş Akış";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Eşzamanlı Akış";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Bileşen temizlenememesi";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Hava çıkarılamadı";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Az infüzyon";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Hastanın kanı (infüze edilen kan ürünleri değil)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Solüsyonlar / Kan Ürünleri";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Sızıntı Hasarı/Delik";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "bağlantı kesilmesi";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Sızıntı";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "İlaç basınçlı infüzyonla veriliyordu sırınga veya IV pompa";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "İkincil torba birincil torbadan daha düşük seviyedeydi";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "İkincil torba, birincil torba ile aynı yükseklikte idi";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Kan Pıhtılaşması";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Seti takmadan önce kateter yıkanamadı";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Kıvrılmış Hat";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Hat / enjeksiyon bölgesi tıkanması";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Birincil ve İkincil konteyner (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Çok uçlu bir sette akan iki veya daha fazla uç";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Her biri kendi infüzyon pompasına sahip iki uygulama seti";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "Baxter Askısı";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "Baxter Olmayan Askı";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Çantalar aynı yükseklikteydi";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Birincil";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "İkincil";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Ortada";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Aşağıda";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Üstte";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Evet - Pompanın adını ve ürün kodunu giriniz (serbest metin)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Koyu Mavi Sürgülü Klemp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Açık Mavi Sürgülü Klemp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Dişli Klemp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Makaralı Klemp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Beyaz Sürgülü Kelmp";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Evet - Klemp kırıldı veya çatladı";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Hatta Hava ";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Klemp Sorunu";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Koku";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Dişli/Sıkışan Klemp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Makaralı Klemp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Sürgülü Klemp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Kırık / Çatlak";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Açılması zor";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Kapatılması zor";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Eksik ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Açılamıyor";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Kapatılamıyor";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Akış kontrol edilemiyor";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Damlama haznesini sıkmak zor";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Talimatları takip etmek / anlamak zordu";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Ürünün kullanımı zordu";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Çatlak / kırık";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Kesik / parçalanmış";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Bağlanabilir bileşenlerin / bağlı ürünlerin bağlantısının kesilmesi";
translations[DISCONNECTION_OF_CONNECTABLE] = "Bağlanabilir bileşenlerin / bağlı ürünlerin bağlantısının kesilmesi";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Delik / yırtık";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Bağlı bileşenlerin ayrılması";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Yapışmış kapak";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "İkincil ambalajda veya ara kartonda hasar (delikler, yırtılmalar)";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Teslimat sırasında hasarlı nakliye kartonu";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Aşırı sıcak / soğuğa maruz kalma";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Kesici / keskin nesne ile nakliye kartonunu açma";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Yukarıdakilerin hiçbiri";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Basınçlı manşet veya basınçlı enjektör kullanılması";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Yapışmış Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Evcil Hayvanlar (pençelenmiş / çiğnenmiş)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Ürün";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Nakliye Kartonu / kutu";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Ürünün içinde";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Nakliye kartonunun içinde";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Ürünün dış tarafında";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Ürünü başka bir ürüne bağlamada zorluklar";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Ürünün başka bir ürünle bağlantısını kesmede zorluklar";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Gevşek bağlantı";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Tek bir üründe bileşenlerin ayrılması";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Ürünün başka bir üründen ayrılması / ayrıbağlantı kopması";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Nakliye kartonunun dış tarafında";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "İkincil ambalajın/dış torbanın iç tarafında";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "İkincil ambalajın/dış torbanın dış tarafında";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Akış yok";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Kısıtlı veya Kısmen akış mevcut ";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barkod Sorunu - Tarandığında Görüntülenen Yanlış Bilgi";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Tarama zorlukları / taranamaz Barkod";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Okunaksız Etiket";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Yanlış etiket";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Tamamlanmamış Etiket";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Etiketler (ürün, kutu / karton, nakliye listesi) aynı ürün bilgilerine sahip değildir";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Etiket başka bir ürüne çok benzer";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Eksik Etiket";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Eksik Barkod";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Dondurulmuş ürün alındı";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Çözülmüş ürün alındı";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Evet, Alarm bilinmiyor";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Evet, Belirtiniz";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Evet - transfer set tamamen açılamadı";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Evet - transfer seti tamamen kapatılamadı";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Ja - Döner başlıklı klemp o kadar sıkıydı ki transfer seti hiç açılamadı";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Ja - Döner başlıklı klemp o kadar sıkıydı ki transfer seti hiç kapanamadı";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Kutu veya dış torba";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Son Dolum Hattındaki Mavi Klemp";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Kaset";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Boşaltım Hattı Konektörü ve Çekme Halkası Kapağı";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Atık numune bölgesi";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Hatlar";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Uç/Delme Konnektörleri";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Düzenleyici";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Hasta Hattındaki Çekme Halkası Kapakları/ Uç koruyucusu";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Çekme Halkası Kapakları / Uç Koruyucuları";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Isıtıcı Hattındaki Kırmızı Kelmp";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Geçici Kaynak";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Yedek Hattaki Beyaz Klemp";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Bej Kateter Adaptör Konnektörü";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Çip Ekleme";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Koyu Mavi Konektör";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Açık Mavi Ana Gövde";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Açık Mavi Çekme Halkası Kapağı";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Açık Mavi Tıkayıcı Parçalar";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Silikon Hat";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Titanyum Uç";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV Flaş Uç";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Beyaz Döner Başlık/ Kulp";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Evet: Hasarı açıklayınıx (serbest metin)";
translations[OPTION_MONTHOPTIONS_JAN] = "Ocak";
translations[OPTION_MONTHOPTIONS_FEB] = "Şubat";
translations[OPTION_MONTHOPTIONS_MAR] = "Mart";
translations[OPTION_MONTHOPTIONS_APR] = "Nisan";
translations[OPTION_MONTHOPTIONS_MAY] = "Mayıs";
translations[OPTION_MONTHOPTIONS_JUN] = "Haziran";
translations[OPTION_MONTHOPTIONS_JUL] = "Temmuz";
translations[OPTION_MONTHOPTIONS_AUG] = "Agustos";
translations[OPTION_MONTHOPTIONS_SEP] = "Eylül";
translations[OPTION_MONTHOPTIONS_OCT] = "Ekim ";
translations[OPTION_MONTHOPTIONS_NOV] = "Kasım";
translations[OPTION_MONTHOPTIONS_DEC] = "Aralık";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Diğer";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Diğer";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Yukarıdakilerin hiçbiri";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Hayır";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Evet";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Hayır";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Evet";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Hayır";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Evet";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Hayır";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Evet";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Soruldu, bilinmiyor";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Hayır";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Bilinmiyor";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Evet";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Hayır";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Evet";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Hayır";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Evet";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Hayır";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Evet";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Hayır";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Evet";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Hayır";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Evet";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Hayır";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Evet";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Hayır";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Evet";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Hayır";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Evet";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Hayır";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Evet";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Hayır";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Evet";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Hayır";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Evet";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Hayır";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Evet";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Hayır";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Evet";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Hayır";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Hayır";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Evet";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Hayır";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Evet";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Hayır";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Evet";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Hayır";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Evet";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Hayır";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Evet";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Hayır";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Evet";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Hayır";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Evet";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Hayır";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Evet";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Hayır";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Evet";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Hayır";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Evet";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Hayır";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Hayır";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Evet";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Hayır";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Evet";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Hayır";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Evet";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Hayır";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Evet";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Hayır";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Evet";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Hayır";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Evet";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Hayır";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Evet";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Hayır";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Evet";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Hayır";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Bilinmiyor";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Evet";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Hayır";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Evet";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Hayır";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Evet";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Hayır";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Evet";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Hayır";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Evet";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Hayır";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Evet";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Hayır";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Evet";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Hayır";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Evet";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Hayır";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Evet";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Hayır";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Evet";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Hayır";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Evet";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Hayır";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Evet";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Hayır";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Evet";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Hayır";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Evet";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Hayır";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Evet";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Hayır";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Evet";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Hayır";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Evet";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Hayır";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Evet";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Hayır";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Evet";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Hayır";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Evet";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Evet";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Hayır";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Evet";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Hayır";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Evet";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Hayır";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Evet";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Hayır";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Evet";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Hayır";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Evet";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Hayır";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Evet";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Hayır";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Evet";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Hayır";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Evet";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Hayır";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Evet";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Hayır";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Evet";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "Hayır";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Hayır";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Evet";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "Hayır";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Hayır";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Evet";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Hayır";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Evet";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Hayır";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Evet";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Hayır";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Evet";
translations[OPTION_WITHPUMPOPTIONS_NO] = "Hayır";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Hayır";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Evet";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "Hayır";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Hayır";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Evet";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Hayır";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Evet";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Hayır";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Evet";
translations[OPTION_GELPACKSOPTIONS_NO] = "Hayır";
translations[OPTION_GELPACKSOPTIONS_YES] = "Evet";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Hayır";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Evet";
translations[OPTION_ALARMOPTIONS_NO] = "Hayır";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Hayır";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Evet";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Hayır";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Hayır";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Evet";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Hayır";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Evet";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Hayır";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Hayır";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Evet";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Diğer (Serbest Metin)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Hayır";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Evet";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Hayır";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Evet";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Hayır";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Evet";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Soruldu, bilinmiyor";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Soruldu, bilinmiyor";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "Hayır";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Yukarıdakilerin hiçbiri";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "Hayır- rengi tarif ediniz (serbest metin)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Evet - Kullanılan aracı belirtiniz (Serbest Metin)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Ayrılma";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Hiçbiri";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Evet - Diğer (Serbest Metin)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "Hayır";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogram";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Pound";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "Hayır";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[PLEASE_ENTER_THE_VALUE] = "Lütfen değeri giriniz";
translations[PLEASE_SELECT_THE_VALUE] = "Lütfen değeri seçiniz";
translations[PLEASE_SELECT_THE_DATE] = "Lütfen tarihi seçin";
translations[PLEASE_CHOOSE_THE_VALUE] = "Lütfen değeri seçiniz";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Bilinmiyor";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "Büyük Britanya";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "Kosova";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "Kuzey İrlanda";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "Afganistan";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "Aland Adaları";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "Arnavutluk";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "Cezayir";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "Ameriakan Samoası";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "Andorra";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "Angola";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "Anguilla";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "Antarktika";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "Antigua ve Barbuda";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "Arjantin";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "Ermenistan";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "Aruba";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "Avusturalya";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "Avusturya";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "Azerbaycan";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "Bahamalar";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "Bahreyn";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "Bangladeş";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "Barbados";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "Belarus";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "Belçika";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "Belize";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "Benin";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "Bermuda";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "Butan";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "Bolivya";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "Bosna Hersek";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "Botsvana";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "Buvet Adası";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "Brezilya";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "İngiliz Hint Okyanusu Bölgesi";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "Brunei Darussalam";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "Bulgaristan";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "Burkina Faso";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "Burundi";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "Kamboçya";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "Kamerun";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "Kanada";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "Cape Verde";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "Cayman Adaları";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "Orta Afrika Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "Çad";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "Şili";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "Çin";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "Christmas Adası";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "Keeling Adaları";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "Kolombiya";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "Komorlar";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "Kongo";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "Kongo Demokratik Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "Cook Adaları";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "Kosta Rika";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "Fildişi Sahili";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "Hırvatistan";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "Küba";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "Kıbrıs";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "Çekya";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "Danimarka";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "Cibuti";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "Dominica";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "Dominik Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "Ekvator";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "Mısır";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "El Salvador";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "Ekvator Ginesi";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "Eritre";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "Estonya";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "Etiyopya";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "Falkland Adaları (Malvinas)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "Faroe Adaları";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "Fiji";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "Finlanda";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "Fransa";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "Fransız Guyanası";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "Fransız Polinezyası";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "Fransız Güney Bölgeleri";
translations[OPTION_COUNTRYOPTIONS_GABON] = "Gabon";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "Gambia";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "Gürcistan";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "Almanya";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "Gana";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "Cebelitarık";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "Yunanistan";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "Grönland";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "Grenada";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "Guadeloup";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "Guam";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "Guatemala";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "Guernsey";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "Gine";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "Gine-Bissau";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "Guyana";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "Haiti";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "Heard Adası ve McDonald Adaları";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "Vatikan Şehir Devleti";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "Honduras";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "Hong Kong";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "Macaristan";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "İzlanda";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "Hindistan";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "Endonezya";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "İran İslam Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "Irak";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "İrlanda";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "Man Adası";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "İsrail";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "İtalyanca";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "Jameyka";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "Japonya";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "Jersey";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "Ürdün";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "Kazakistan";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "Kenya";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "Kiribati";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "Kore Demokratik Halk Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "Kore Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "Kuveyt";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "Kırgızistan";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "Lao Halkın Demokratik Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "Letonya";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "Lübnan";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "Lezoto";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "Liberya";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "Libya";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "Liçestein";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "Litvanya";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "Lüksemburg";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "Makao";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "Makedonya";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "Madagaskar";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "Malavi";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "Malezya";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "Maldivler";
translations[OPTION_COUNTRYOPTIONS_MALI] = "Mali";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "Malta";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "Marshall Adaları";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "Martinik";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "Moritanya";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "Mauritus";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "Mayo";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "Meksiko";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "Mikronezya Federasyon Devletleri";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "Moldova";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "Monako";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "Mogolistan";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "Karadağ";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "Monserrat";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "Fas";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "Mozambik";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "Myanmar";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "Namibya";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "Nauru";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "Nepal";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "Hollanda";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "Yeni Kaledonya";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "Yeni Zelanda";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "Nikaragua";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "Nijer";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "Nijerya";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "Niue";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "Norfolk Adası";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "Kuzey Mariana Adaları";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "Norveç";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "Umman";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "Pakistan";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "Palau";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "Filistin";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "Panama";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "Papua Yeni Gine";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "Praguay";
translations[OPTION_COUNTRYOPTIONS_PERU] = "Peru";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "Filipinler";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "Küba";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "Polonya";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "Portekiz";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "Poto Riko";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "Katar";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "Reunion";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "Romanya";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "Rusya Federasyonu";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "Ruanda";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "Saint Barthelemy";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "Saint Helena";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "Saint Kitts ve Nevis";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "Saint Lucia";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "Saint Martin";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE AND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT AND THE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME AND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "Suudi Arabistan";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "Senegal";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "Sırbistan";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "Seyşeller";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "Singapur";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "Slovakya";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "Slovenya";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "Solomon Adaları";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "Somali";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "Güney Afrika";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "GÜNEY GÜRCİSTAN VE GÜNEY SANDVİÇ ADALARI";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "İspanya";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "Sri Lanka";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "Sudan";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "Surinam";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD VE JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "Svaziland";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "İsveç";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "İsviçre";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "Suriye Arap Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "Tayvan";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "Tacikistan";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "Tanzanya Birleşik Cumhuriyeti";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "Tayland";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "Togo";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "Tokelau";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "Tonga";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "Trinidad ve Tobago";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "Tunus";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "Türkiye";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "Türkmenistan";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS VE CAİCOS ADALARI";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "Tuvalu";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "Uganda";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "Ukrayna";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "Brleşik Arap Emirlikleri";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "Birleşik Kırallık";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "Amerika Birleşik Devletleri";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "AMERİKA BİRLEŞİK DEVLETLERİ KÜÇÜK DIŞ ADALARI";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "Uruguay";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "Özbekistan";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "Vanuatu";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "Venezuella";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "Vietnam";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "İngiliz Virgin Adaları";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "Ameriak Virgin Adaları";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLİS VE FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "Batı Sahra";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "Yemen";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "Zambia";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "Zimbabve";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Hayır";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Bilinmiyor";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Evet";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Baxter Ürün Geri Bildirim Portalı için bağlantılı Gizlilik Bildirimini okudum ve anladım.";
translations[PRODUCT_LOT] = "Ürün lot numarası";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Nakliye/Dağıtım Etiketi";
translations[CARTON_LABEL] = "karton etiket";
translations[INTERNAL_PRODUCT_LABEL] = "Dahili Ürün Etiketi";
translations[TITLE_PD_RENAL] = "PD böbrek";
translations[TITLE_SOLUTIONS] = "Çözümler";
translations[TITLE_ACCESS] = "Erişim";
translations[TITLE_ALL_OTHER_PRODUCT] = "Tüm Diğer Ürünler";
translations[REPORTED_PROBLEM] = "Bildirilen Sorun";
translations[LOGIN] = "Giriş yapmak";
translations[SYSTEM_MENU] = "Sistem Menüsü";
translations[INITIATE_PRODUCT_FEEDBACK] = "Ürün Geri Bildirimini Başlat";
translations[FEEDBACK_STATUS] = "Geribildirim Durumu";
translations[OKTACALLBACK] = "OktaGeri Arama";
translations[VALID_EMAIL] = "Lütfen geçerli e-posta adresini giriniz";
translations[VALID_NUMERIC] = "Lütfen numarayı giriniz.";
translations[PLEASE_UPLOAD_IMAGE] = "Lütfen resim (ler) yükleyin";
translations[VALID_DATE] = "Lütfen geçerli bir tarih seçiniz";
translations[QUANTITY] = "Miktar";
translations[EDIT] = "Düzenlemek";
translations[DELETE] = "Silmek";
translations[LOT_SERIAL_NO] = "Parti /Seri No";
translations[LOT_NUMBER_NOT_FOUND] = "Lot numarası bulunamadı";
translations[SEARCHING_LOT_NUMBER] = "Lot numarası aranıyor";
translations[PRODUCT_CODE_NOT_FOUND] = "Ürün kodu bulunamadı";
translations[SEARCHING_PRODUCT_CODE] = "Ürün kodu aranıyor";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Dosya türlerine (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) izin verilmez";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "Eklemeye çalıştığınız dosya depolama sınırını aşıyor. Lütfen sıkıştırın veya farklı bir dosya ekleyin.";
translations[IMAGE_ICON] = "Seçeneği seçmek için görüntü simgesine tıklayın";
translations[LOGIN_TO_ACCOUNT] = "Hesaba giriş yap";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Hesabınıza giriş yapın";
translations[BAXTER_EMAIL_ADDRESS] = "Baxter E-posta Adresi";
translations[PASSWORD] = "Şifre";
translations[SIGN_IN] = "Kayıt olmak";
translations[UNKNOWN] = "Bilinmiyor";
translations[ASKED_UNKNOWN] = "Soruldu, bilinmiyor";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Ülke Seçiniz";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Çince (Basitleştirilmiş Çince)";
translations[DUTCH] = "Flemenkçe";
translations[ENGLISH] = "İngilizce";
translations[FRENCH] = "Fransızca";
translations[GERMAN] = "Almanca";
translations[ITALIAN] = "İtalyanca";
translations[JAPANESE] = "Japonca";
translations[KOREAN] = "Korece";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarin (Geleneksel Çince)";
translations[POLISH] = "Lehçe";
translations[PORTUGUESE] = "Portekizce";
translations[SPANISH] = "İspanyolca";
translations[THAI] = "Tayca";
translations[TURKISH] = "Türkçe";
translations[VIETNAMESE] = "Vietnamca";
translations[BROWSE] = "Araştır";
translations[FEEDBACK_SUBMITTED] = "Geri Bildirim Gönderildi";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Ürün deneyimi geri bildiriminiz başarıyla gönderildi. Raporlamanız için teşekkürler. Bir referans numarası içeren bir e-posta alacaksınız. Medikal ürün sağlayıcısı olarak, ürünümüzle ilgili müşteri memnuniyeti ve geri bildirim, en kaliteli ürünleri sunma hedefimiz için esastır. Lütfen iletişime geçin";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "Sorularınız veya ek bilgileriniz varsa.";
translations[CLOSE] = "Kapat";
translations[PATIENT_AGE] = "Hasta Yaşı";
translations[ENTER_AGE] = "Yaş Girin";
translations[PATIENT_DOB] = "Hasta Doğum Günü";
translations[RELEVANT_ATTACHMENTS] = "Lütfen ilgili ekleri sağlayınız";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "Baxter Hesap  bilgilerinizi giriniz";
translations[GET_PRODUCT_DETAILS] = "Ürün Detaylarını Alın";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Bildirilen sorunun yerini belirlemek için yukarıdaki diyagramı (şekil 2) kullanın.";
translations[FACILITY_ADDRESS] = "Kurum Adresi";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Başka kurum Adresi";
translations[CHOOSE_PRODUCT_CODE] = "Girilen Lot/Seri Numarası için Ürün Kodu'nu seçiniz";
translations[DECLINE] = "ReddeT";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS VE SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURACAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "GÜNEY SUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "bu alan için yardım metninin mevcut olduğunu gösterir";
translations[YOUR_FIRST_NAME] = "Adınız";
translations[YOUR_LAST_NAME] = "Soy adınız";
translations[MY_FIRST_NAME] = "Adım";
translations[MY_LAST_NAME] = "Soyadım";
translations[PATIENT_FIRST_NAME] = "Hastanın Adı";
translations[PATIENT_LAST_NAME] = "Hastanın Soyadı";
translations[REPORTER_FIRST_NAME] = "Raporlayıcının adı";
translations[REPORTER_LAST_NAME] = "Raporlayıcının soyadı";
translations[EMPLOYEE_FIRST_NAME] = "Çalışan Adı";
translations[EMPLOYEE_LAST_NAME] = "Çalışan Soyadı";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Son Kullanıcı/Müşteri İrtibat Kişi Adı";
translations[END_USER_CUSTOMER_LAST_NAME] = "Son Kullanıcı/Müşteri İlgili Kişi Soyadı";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Ek İlgili Kişinin Adı";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Ek İlgili Kişinin Soyadı";
translations[COPYRIGHT] = "Telif hakkı ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "Tüm hakları saklıdır | Sürüm";
translations[ADD_ADDITIONAL_CONTACT] = "Ek Kişi Ekle";
translations[CONTACT_ME] = "Müşteri iletişime geçilmesini istemiyor. Herhangi bir ek soru için benimle iletişime geçin.";
translations[DO_NOT_CONTACT] = "İletişime Geçmeyiniz";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Son kullanıcı/müşteri tesis adı";
translations[END_USER_CUSTOMER_PHONE] = "Son kullanıcı/müşteri tesisi telefon numarası";
translations[END_USER_CUSTOMER_EMAIL] = "Son Kullanıcı/Müşteri E-posta Adresi";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Son Kullanıcı/Müşteri Tesis Adresi";
translations[SAME_AS_PATIENT_ADDRESS] = "Hasta Adresi ile aynı";
translations[SAME_AS_REPORTER_ADDRESS] = "Raporlayıcının Adresi ile aynı";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Son Kullanıcı/Müşteri Tesis Adresi ile aynı";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Bildirilen sorunun yerini belirlemek için yukarıdaki diyagramı kullanınız (şekil 3)";
translations[CONTACT_US] = "Bize Ulaşın";
translations[LANDING_BRIEF_FOR_DEVICE] = "Cihaz onarımı, parça, hizmet veya teknik destek için lütfen yerel teknik servis destek ekibinizle iletişime geçin.";
translations[PATIENT_SEX] = "Hasta Seks";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Cisgender erkek/erkek çocuk";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Cisgender kadın/kız";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Transseksüel erkek/trans erkek/kadından erkeğe";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Trans kadın/trans kadın/erkekten kadına";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Diğer cinsiyet kategorisi; lütfen belirtin";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Yanıtlamayı reddet";
translations[ATTENTION_NEEDED] = "!!! ACİL DİKKAT GEREKLİ: Ürün Geri Bildirim Portalı gönderiminiz BAŞARISIZ OLDU!";
translations[SUBMIT_ERR_MSG] = "Yeniden göndermek için lütfen Tamam'ı tıklayın ve ardından Gönder Veya şikayetinizi (@@@) adresine e-posta ile gönderin.";
translations[SUBMIT_RETRY_MSG] = "Tekrar gönderdiyseniz, lütfen Ürün Geri Bildirim Portalı'ndan e-posta kutunuza bir onay e-postası aldığınızı doğrulayın. Onay e-postası alınmadıysa, gönderim başarılı olmadı ve şikayetinizi (@@@) adresine e-posta ile göndermelisiniz.";
translations[OK] = "OK";

export default lang;